import React from 'react';
import CreateIcon from '@mui/icons-material/Create';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';
import { Card } from '@rentspree/component-2023.components.organisms.card';

import { ActivityItem } from '../../types/activity';

export interface RecentActivityProps {
  title?: string;
  activities: ActivityItem[];
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const RecentActivity: React.FC<RecentActivityProps> = ({
  title = 'Recent Activity',
  activities,
  width = 405,
  height,
  className,
  style,
}) => {
  const defaultIcon = (
    <CreateIcon fontSize='small' style={{ color: '#6b7280' }} />
  );

  return (
    <div style={{ width }} className={className || ''}>
      <Card
        style={{
          padding: 0,
          borderRadius: 12,
          border: '1px solid #f3f4f6',
          boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.05)',
          ...(height && { height }),
          ...style,
        }}
        data-testid='recent-activity'
      >
        <div style={{ padding: '25px' }}>
          <Typography
            variant='h5'
            style={{
              fontWeight: 600,
              color: '#222222',
              marginBottom: 27,
            }}
          >
            {title}
          </Typography>

          {activities.map(activity => (
            <div
              key={activity.id}
              style={{ display: 'flex', gap: 12, marginBottom: 16 }}
            >
              <div
                style={{
                  background: '#f3f4f6',
                  borderRadius: '50%',
                  width: 32,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {activity.icon || defaultIcon}
              </div>
              <div style={{ flex: 1 }}>
                <Typography
                  variant='body1'
                  style={{
                    color: '#374151',
                    marginBottom: 4,
                  }}
                >
                  {activity.message}
                </Typography>
                <Typography
                  variant='body2'
                  style={{
                    color: '#6b7280',
                    fontSize: '14px',
                  }}
                >
                  {activity.timeAgo}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
